/** The element that scrolls a node: its nearest ancestor with a vertical overflow, otherwise the page. */
export const getScrollParent = (node: HTMLElement | null): HTMLElement => {
  let current = node?.parentElement ?? null;
  while (current && current !== document.body && current !== document.documentElement) {
    const { overflowY } = window.getComputedStyle(current);
    if (overflowY === 'auto' || overflowY === 'scroll') return current;
    current = current.parentElement;
  }
  return (document.scrollingElement as HTMLElement | null) ?? document.documentElement;
};
